/**
 * Pure form styling preset data shared by the renderer and the Design UI.
 */

export const FORM_SHAPES = [
  { id: 'square', name: 'Square', fieldRules: { 'border-radius': '0' } },
  { id: 'slight', name: 'Slight', fieldRules: { 'border-radius': '0.25rem' } },
  { id: 'medium', name: 'Medium', fieldRules: { 'border-radius': '0.5rem' } },
  { id: 'round', name: 'Round', fieldRules: { 'border-radius': '1rem' } },
  { id: 'pill', name: 'Pill', fieldRules: { 'border-radius': '9999px' } }
];

export const FORM_STYLES = [
  {
    id: 'filled',
    name: 'Filled',
    fieldRules: { background: 'rgba(0,0,0,0.04)', border: '1px solid transparent' }
  },
  {
    id: 'outline',
    name: 'Outline',
    fieldRules: { background: 'transparent', border: '1px solid var(--bodyTextColor, #888)' }
  },
  {
    id: 'underline',
    name: 'Underline',
    fieldRules: {
      background: 'transparent',
      border: '0',
      'border-bottom': '1px solid var(--bodyTextColor, #888)',
      'border-radius': '0',
      padding: '0.5rem 0'
    }
  },
  {
    id: 'ghost',
    name: 'Ghost',
    fieldRules: { background: 'transparent', border: '1px dashed rgba(0,0,0,0.18)' }
  }
];

export const FORM_SUBMIT_STYLES = [
  { id: 'square', name: 'Square', submitRules: { 'border-radius': '0' } },
  { id: 'pill', name: 'Pill', submitRules: { 'border-radius': '9999px' } },
  { id: 'round', name: 'Round', submitRules: { 'border-radius': '0.5rem' } },
  {
    id: 'outline',
    name: 'Outline',
    submitRules: { background: 'transparent', border: '1px solid currentColor' }
  }
];
